<po-page-list #poPageListComponent
  p-title="Pedido de Venda - Programação"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
  [p-actions]="actionPage"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens.items"
    p-spacing="small"
    p-hide-table-search="true"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm"><po-input
      class="po-md-6"
      name="CC5NUM"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CC5NUM"
      p-label="Cód. Pedido"
      [p-maxlength]="6"
    ></po-input>
    <po-number
      class="po-md-6"
      name="NC5XDSEMAN"
      [(ngModel)]="tabelaPrincipalFiltro.dados.NC5XDSEMAN"
      p-label="Semana"
    ></po-number>
    <po-datepicker
      class="po-md-6"
      name="DC5FECENT_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC5FECENT_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Dt. Prev de"
    ></po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DC5FECENT_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC5FECENT_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Dt. Prev até"
    ></po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DC5EMISSAO_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC5EMISSAO_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Dt. Emissão de"
    ></po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DC5EMISSAO_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DC5EMISSAO_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Dt. Emissão até"
    ></po-datepicker>
    
  </form>
</po-modal>

<po-modal
  #alteraPedidoModal
  p-title="Alteração da Programação do Pedido"
  p-size="lg" 
  [p-primary-action]="alteraPedidoPrimaryAction"
>
  <po-number
    class="po-md-6"
    name="NC5XDSEMAN"
    [(ngModel)]="pedidoSelecionado.NC5XDSEMAN"
    p-label="Semana"
  ></po-number>
  <po-datepicker
    class="po-md-6"
    name="DC5FECENT"
    [(ngModel)]="pedidoSelecionado.DC5FECENT"
    p-format="dd/mm/yyyy"
    [p-iso-format]="formatExtended"
    p-label="Data Programação"
  ></po-datepicker>

</po-modal>

<po-modal
  #controleLogisticoModal
  p-title="Gerar Relatório de Controle Logístico"
  p-size="lg" 
  [p-primary-action]="controleLogisticoPrimaryAction"
>
  <po-number
    class="po-md-4"
    name="NC5XDSEMAN"
    [(ngModel)]="controleLogistico.NC5XDSEMAN"
    p-label="Semana"
  ></po-number>
  <po-datepicker
    class="po-md-4"
    name="DC5FECENT_DE"
    [(ngModel)]="controleLogistico.DC5FECENT_DE"
    p-format="dd/mm/yyyy"
    [p-iso-format]="formatExtended"
    p-label="Dt. Programação De"
  ></po-datepicker>
  <po-datepicker
    class="po-md-4"
    name="DC5FECENT_ATE"
    [(ngModel)]="controleLogistico.DC5FECENT_ATE"
    p-format="dd/mm/yyyy"
    [p-iso-format]="formatExtended"
    p-label="Dt. Programação Até"
  ></po-datepicker>

</po-modal>
